module.exports = __webpack_public_path__ + "static/media/compaction-equipment.f9b1a18b.jpg";